import { render, staticRenderFns } from "./IDCheck.vue?vue&type=template&id=5875389e&scoped=true&"
import script from "./IDCheck.vue?vue&type=script&lang=js&"
export * from "./IDCheck.vue?vue&type=script&lang=js&"
import style0 from "./IDCheck.vue?vue&type=style&index=0&id=5875389e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5875389e",
  null
  
)

export default component.exports